export class ResponseBuilder {
  constructor (response) {
    this._rawResponse = response
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/response_builder/response_builder.js